import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Modal } from "../../components";
import { setModalTermsClosed } from "../../actions/modals";

// Import styling
import "../../styles/components/_programs.scss";
import "../../styles/components/modals/_edit-program.scss";
import "../../styles/components/_programs.scss";
import { fetchTerms } from "../../actions/terms";

function TermsModal() {
  const { termsOpen } = useSelector((state) => state.modals);
  const termsContent = useSelector((state) => state.terms.content);

  const dispatch = useDispatch();

  useEffect(() => {
    const getTerms = async () => {
      dispatch(fetchTerms());
    };
    getTerms();
  }, [dispatch]);

  const handleClose = useCallback(
    () => dispatch(setModalTermsClosed()),
    [dispatch]
  );

  // If there is a selected program, return the modal allowing the user to edit the donation
  return (
    <Modal isOpen={termsOpen} modalName="terms" onClose={handleClose}>
      <div
        className="remodal remodal--terms_and_conditions"
        data-remodal-id="terms-and-conditions"
      >
        <div className="remodal__terms_head">
          <h1>{termsContent.bpoint_dd_terms_title}</h1>
          <p>{termsContent.bpoint_dd_terms_blurb}</p>
        </div>

        <div
          className="remodal__terms_body"
          dangerouslySetInnerHTML={{
            __html: termsContent.bpoint_dd_terms_content,
          }}
        />
      </div>
    </Modal>
  );
}

export default TermsModal;
